import { mapTourActiveElementStyles } from 'pages/Map/components/MapTour/MapTour.styled';
import styled, { css } from 'styled-components';

export const FooterWrapper = styled.div`
    position: absolute;
    max-width: fit-content;
    padding: 0.75rem;
    bottom: 2.25rem;
    left: 0;
    right: 0;
    margin: 0 auto;

    @media (max-width: ${({ theme }) => theme.breakpoints.S.max}px) {
        z-index: 3;
    }
`;

const tourActiveStyles = css`
    ${mapTourActiveElementStyles};
    padding: 2rem;
    transform: translate(0, 0);
`;

export const ZoneTabsWrapper = styled.div<{ isMapTourActiveElement: boolean }>`
    ${({ isMapTourActiveElement }) => isMapTourActiveElement && tourActiveStyles};
`;

export const ZoneTabs = styled.div`
    margin: auto;
    overflow: auto;
    padding: 0.4rem;
    border-radius: 4rem;
    display: flex;
    background: ${({ theme }) => theme.colors.grey['300']};
    box-shadow: 0 2px 8px 0 rgba(176, 188, 200, 0.64);
    max-width: fit-content;
`;
